package modysy.simulation.events

import modysy.datastructures.Vector2
import org.scalajs.dom
import scala.scalajs.js
import modysy.view.ImageProvider
import scala.util.Random
import modysy.tools.EnergyStorage
import modysy.Clock

class coin(enable: Boolean = true, chance: Int = 500) {
  private var posx: Int = newwidth()
  //private var posx: Int = 0
  private var posy: Int = newheight()
  //private var posy: Int = 0
  private var timeleft: Int = 0
  private var timeref = js.Date.now()
  private var imageName: String = "coin3"
  var existingCoin: Boolean = false
  var firstTime: Boolean = true

  def render(ctx: dom.CanvasRenderingContext2D) = {
    ImageProvider
      .drawImgFnc(
        ImageProvider.getImage(this.imageName),
        (dom.window.innerWidth.toInt / 20).toInt,
        (dom.window.innerWidth.toInt / 20).toInt
      )
      .apply(ctx, this.posx, this.posy)
  }

  def abs(a: Int): Int = {
    if (a < 0)
      return -a
    return a
  }

  def newwidth(): Int = {
    var RNG: Random = new Random((js.Date.now() % 2147483647).toInt)
    var zahl = RNG.nextInt((js.Date.now() % 2147483647).toInt)
    zahl = zahl % (dom.window.innerWidth.toInt / 20 * 19 - 100).toInt
    zahl = abs(zahl) + 50
    return zahl
  }

  def newheight(): Int = {
    var RNG: Random = new Random((js.Date.now() % 2147483647).toInt)
    var zahl = RNG.nextInt((js.Date.now() % 2147483647).toInt)
    zahl = zahl % (dom.window.innerHeight.toInt - dom.window.innerWidth.toInt / 20 - 100).toInt
    zahl = abs(zahl) + 50
    return zahl
  }

  def coinOrClock(): Unit = {
    if ((js.Date.now() % 2).toInt.equals(1))
      this.imageName = "coin3"
    else this.imageName = "clock"
  }

  def updateCoin(): Unit = {
    if (existingCoin == false)
      return
    this.posx = newwidth()
    //this.posx = 0
    this.posy = newheight()
    //this.posy = 0
    coinOrClock()
  }

  def updateTime(): Unit = {
    if (this.existingCoin == false)
      return
    if (this.firstTime == true) {
      this.timeref = js.Date.now()
      this.firstTime = false
      this.timeleft = 2000
      return
    }
    timeleft -= (js.Date.now() - this.timeref).toInt
    this.timeref = js.Date.now()
    if (timeleft < 0) {
      this.firstTime = true
      this.existingCoin = false
    }
  }

  def createNewCoin(byForce: Boolean = false): Unit = {
    if (this.existingCoin == true || this.enable == false)
      return
    var RNG: Random = new Random((js.Date.now() % 2147483647).toInt)
    var zahl = RNG.nextInt((js.Date.now() % 2147483647).toInt)
    zahl = zahl % this.chance
    if (zahl.equals(1) || byForce == true) {
      this.existingCoin = true
      updateCoin()
    }
  }

  def checkClick(mouse: Vector2, energy: EnergyStorage, clock: Clock): Unit = {
    if (this.existingCoin == false)
      return
    var middle: Vector2 = new Vector2(
      this.posx + (dom.window.innerWidth.toInt / 40).toInt,
      this.posy + (dom.window.innerWidth.toInt / 40).toInt
    )
    var distance: Vector2 = middle - mouse
    if (distance.norm <= (dom.window.innerWidth.toInt / 40).toInt) {
      this.firstTime = true
      this.existingCoin = false
      if (this.imageName.equals("coin3"))
        energy.addEnergy(50)
      else clock.addTime(2)
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/events/coin.scala